import { render } from "./WpPost.html?vue&type=template&id=5d3a4f4b&ts=true&external"
import script from "./WpPost.ts?vue&type=script&lang=ts&external"
export * from "./WpPost.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__